import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

const ChartCardSkeleton = () => (
  <Card>
    <CardHeader className="flex flex-row items-center justify-between space-y-0" style={{ padding: "5px" }}>
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-6 w-6 rounded" />
    </CardHeader>
    <CardContent style={{ padding: "5px" }}>
      <Skeleton className="h-[250px] w-full rounded-md" />
    </CardContent>
  </Card>
);

interface UtilisationSkeletonProps {
  count?: number;
  filterCount?: number;
}

const UtilisationSkeleton = ({ count = 3, filterCount = 6 }: UtilisationSkeletonProps) => {
  const cards = Array.from({ length: count });
  return (
    <div className="space-y-6">
      {/* Filter bar skeleton */}
      <div className="flex flex-wrap gap-2 items-center">
        {Array.from({ length: filterCount }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-36 rounded-md" />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-2">
        {cards.map((_, idx) => {
          const isOddLast = idx === cards.length - 1 && cards.length % 2 !== 0;
          return (
            <div key={idx} className={isOddLast ? "lg:col-start-2 lg:col-span-2" : "lg:col-span-2"}>
              <ChartCardSkeleton />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UtilisationSkeleton;
